import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

const Countdown = ({ seconds, children, onFinish }) => {
  const [remaining, setRemaining] = useState(seconds)

  useEffect(() => {
    const id = setInterval(() => {
      setRemaining(prev => {
        if (prev <= 1) {
          clearInterval(id)
          onFinish && onFinish()
          return 0
        }
        return prev - 1
      })
    }, 1000)
    return () => clearInterval(id)
  }, [seconds, onFinish])

  useEffect(() => {
    setRemaining(seconds)
  }, [seconds])

  if (typeof children !== 'function') {
    return null
  }

  return children(remaining)
}

Countdown.propTypes = {
  seconds: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired,
  onFinish: PropTypes.func
}

export default Countdown
